<div class="fs-2 with-close" mat-dialog-title>
    Confirmation
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <p class="text-center mb-0" [innerHTML]="data.message">
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline-danger">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()" class="btn btn-danger">
        Valider
    </button>
</div>
